export default __webpack_public_path__ + "static/media/my-task-dark.0d1a8f06.svg";